import { render, staticRenderFns } from "./MemberActions.vue?vue&type=template&id=2af4f6d8"
import script from "./MemberActions.vue?vue&type=script&lang=js"
export * from "./MemberActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports